import React, { useEffect, useState } from 'react';
import {
  Button,
  ButtonGroup,
  Form,
  Nav,
  Offcanvas,
  Spinner
} from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import searchVolumeApi, {
  useLazyGetSearchVolumeDetailsChartQuery
} from '@/app/KeywordResearch/api/searchVolumeApi';
import keywordPlannerApi, {
  useLazyGetSearchVolumeDetailsChartQuery as useLazyGetSearchVolumeDetailsChartQuery1
} from '@/app/KeywordResearch/api/keywordPlannerApi';
import { useGetUserInfoQuery } from '@/app/common/api/authApi';
import { useLocation } from 'react-router-dom';
import SearchVolumeDrawerPreload from '@/app/KeywordResearch/components/SearchVolumeDrawerPreload';
import LineTimeChart from '@/app/common/components/LineTimeChart';
import { getColor } from '@/helpers/utils';
import DrawerWrapper from '@/app/common/components/DrawerWrapper';
import { hideDrawer } from '@/app/common/reducers/drawer';


const SearchVolumeDrawer = () => {
  const [chartData, setChartData] = useState(null);
  const { data: userInfo } = useGetUserInfoQuery();
  const dispatch = useDispatch();
  const { key, payload } = useSelector(state => state.drawer);
  const { location_code, language_code, keyword, domain_slug } = payload ?? '';
  const [getSearch1] = useLazyGetSearchVolumeDetailsChartQuery();
  const [getSearch2] = useLazyGetSearchVolumeDetailsChartQuery1();
  const { pathname } = useLocation();
  useEffect(() => {
    if (language_code && location_code && keyword && key === 'search_volume') {
      if (pathname.includes('planner'))
        getSearch2({
          location_code,
          language_code,
          domain_slug,
          keyword: decodeURIComponent(keyword)
        })
          .unwrap()
          .then(res => {
            setChartData(res);
          })
          .catch(() => {
            setChartData({ data: [] });
          });
      if (pathname.includes('search-volume'))
        getSearch1({
          location_code,
          language_code,
          domain_slug,
          keyword: decodeURIComponent(keyword)
        })
          .unwrap()
          .then(res => {
            setChartData(res);
          })
          .catch(() => {
            setChartData({ data: [] });
          });
    }

    return () => {
      setChartData(null);
    };
  }, [key, location_code, language_code, domain_slug, keyword, pathname]);

  return (
    <DrawerWrapper
      show={key === 'search_volume'}
      title={
        <div className="d-flex flex-wrap gap-3 align-items-center">
          <h6 className="m-0 fw-light">
            نمودار روند جستجو &nbsp;
            <span className="fw-bolder">
              ( {keyword ? decodeURIComponent(keyword) : ''} )
            </span>
          </h6>
        </div>
      }
    >
      <div className="mt-4">
      {chartData ? (
        <LineTimeChart
          topLabel="روند جستجو"
          dates={chartData ? chartData?.data.map(item => item.updated_at) : []}
          series={
            chartData
              ? [
                  {
                    name: 'روند جستجو',
                    data: chartData?.data?.map(
                      item => item.search_volume_miztols
                    ),
                    color: getColor('navbar-vertical-default-link-active-color')
                  }
                ]
              : []
          }
        />
      ) : (
        <SearchVolumeDrawerPreload />
      )}
      </div>
    </DrawerWrapper>
  );
};

export default SearchVolumeDrawer;
